import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flexBasis", "flexGrow", "flexShrink", "footerContent", "headerContent", "maxHeight", "Overhang", "scrollDirection", "scrollElementRef", "blockSize", "data-scrolling-column"];
import { useContext } from 'react';
import styled from 'foundations-theming/utils';
import { ShareScrollElement } from './ShareScrollElement';
import { ScrollContainer } from '../ScrollContainer/ScrollContainer';
import { toPx } from '../../../utils/toPx';
import { TFlex } from '../TFlex';
import { usePanelContext } from '../../context';
import { useScrollingColumnsContext } from '../ScrollingColumns/ScrollingColumnsContext';
import { DialogContext } from '../Dialog/DialogContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.header.withConfig({
  displayName: "ScrollingColumn__StyledHeader",
  componentId: "sc-19gs15d-0"
})(({
  theme,
  $inMultiColumn
}) => {
  return {
    paddingBottom: $inMultiColumn ? theme.space['500'] : theme.space['0'],
    '& > :last-child': {
      marginBottom: theme.space['0']
    }
  };
});
const StyledFooter = styled.footer.withConfig({
  displayName: "ScrollingColumn__StyledFooter",
  componentId: "sc-19gs15d-1"
})(({
  theme,
  $inMultiColumn
}) => {
  return {
    paddingTop: $inMultiColumn ? theme.space['500'] : theme.space['0'],
    '& > :last-child': {
      marginBottom: theme.space['0']
    }
  };
});
export const ScrollingColumnInner = styled.div.withConfig({
  displayName: "ScrollingColumn__ScrollingColumnInner",
  componentId: "sc-19gs15d-2"
})(({
  $maxHeight,
  $inPopupModal,
  $inPanel
}) => {
  return Object.assign({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '0',
    maxHeight: $maxHeight && toPx($maxHeight),
    width: '100%'
  }, $inPopupModal && {
    '@media only screen and (min-width: 830px)': {
      flexBasis: '400px'
    }
  }, $inPanel && {
    flexBasis: 'auto'
  }, {
    '@media only screen and (max-width: 544px)': {
      maxHeight: 'none'
    }
  });
});
const InternalScrollingColumn = _ref => {
  let {
      children,
      flexBasis,
      flexGrow,
      flexShrink,
      footerContent,
      headerContent,
      maxHeight,
      Overhang,
      scrollDirection = 'vertical',
      scrollElementRef,
      blockSize = '100%',
      'data-scrolling-column': dataScrollingColumn
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    inModal,
    inPanel
  } = usePanelContext();
  const {
    multiColumn
  } = useScrollingColumnsContext();
  const dialogContext = useContext(DialogContext);

  // Only apply constraint for popup modals, not fullscreen
  const inPopupModal = inModal && dialogContext.use !== 'fullscreen' && dialogContext.use !== 'lightbox' && dialogContext.use !== 'sidebar';
  return /*#__PURE__*/_jsx(TFlex, Object.assign({}, rest, {
    blockSize: multiColumn ? 'auto' : blockSize,
    flexBasis: flexBasis,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexDirection: "column",
    "data-scrolling-column": dataScrollingColumn,
    children: /*#__PURE__*/_jsxs(ScrollingColumnInner, {
      $maxHeight: maxHeight,
      $inPopupModal: inPopupModal,
      $inPanel: inPanel,
      children: [headerContent && /*#__PURE__*/_jsx(StyledHeader, {
        $inMultiColumn: multiColumn,
        children: headerContent
      }), /*#__PURE__*/_jsx(ScrollContainer, {
        autoHeight: true,
        Overhang: Overhang,
        scrollDirection: scrollDirection,
        scrollElementRef: scrollElementRef,
        children: children
      }), footerContent && /*#__PURE__*/_jsx(StyledFooter, {
        $inMultiColumn: multiColumn,
        children: footerContent
      })]
    })
  }));
};
export const ScrollingColumn = ShareScrollElement(InternalScrollingColumn);
ScrollingColumn.displayName = 'ScrollingColumn';